import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=16a5c523&"
import script from "./Administracion.vue?vue&type=script&lang=js&"
export * from "./Administracion.vue?vue&type=script&lang=js&"
import style0 from "./Administracion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports